import Ajax from '../../../../common/js/Ajax.js';
import MessageUtils from '../../../../common/js/MessageUtils.js';
import Widget from '../../../../common/js/Widget.js';

export default class AdminWidget extends Widget {

	constructor($widget) {
		super($widget);
		Ajax.rpc('/isLoggedIn', loggedIn => {
			if (loggedIn) {
				this.show();
			} else {
				window.location.href = '/admin/login';
			}
		}, error => {
			this.show();
			MessageUtils.error($widget, 'Failed to check login', error);
		});
	}

}
